<template>
  <div class="service-card-wrap" @click="toDetail">
    <MediaWrap :url="picture" class="img-wrap" :height="149"></MediaWrap>
    <div class="infos-wrap">
      <a-row class="title-wrap" type="flex">
        <a-col :span="20">
          <div class="title">{{ instance.name }}</div>
        </a-col>
        <a-col :span="4">
          <div class="icon-wrap">
            <span class="iconItem">
              <a-icon type="eye" :style="{ color: '#364759' }" />
              <span>{{ instance.browseNum }}</span>
            </span>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 0]">
        <a-col :span="8">
          <span>服务类型：{{ instance.thirdServiceTypeStr }}</span>
        </a-col>
        <a-col :span="8">
          <span class="single-omit">服务区域：{{ instance.area }}</span>
        </a-col>
        <a-col :span="8">
          <span>发布日期：{{ instance.publishTime }}</span>
        </a-col>
      </a-row>
      <div class="description-wrap four-omit">
        <span> 服务简介：{{ instance.summary }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { viewServerInfo } from '@/api/serverInfo.js'
export default {
  props: {
    instance: Object
  },
  data() {
    return {}
  },
  computed: {
    picture() {
      const { fileVo } = this.instance
      return (fileVo && fileVo[0] && fileVo[0].filePath) || ''
    }
  },
  methods: {
    async toDetail() {
      const { id } = this.instance
      this.$router.push({ name: 'serviceSupportDetail', query: { id } })
      await viewServerInfo(id)
    }
  }
}
</script>
